import React from "react";
import { Modal, ModalBody, Button } from "@windmill/react-ui";

const ConfirmDeleteModal = ({ isOpen, onClose, onConfirm }) => {
  return (
    <Modal
      className="dark:bg-gray-700 bg-white p-4 rounded-lg"
      isOpen={isOpen}
      onClose={onClose}
    >
      <ModalBody className="mt-5">
        <p>Are you sure you want to delete this item?</p>
        <div className="flex justify-end mt-4">
          <Button
            layout="outline"
            onClick={onClose}
            className="w-full sm:w-auto hover:bg-white hover:border-gray-50"
          >
            Cancel
          </Button>
          <Button onClick={onConfirm}>Confirm</Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ConfirmDeleteModal;
